export const SESSION_STALE_TIME_MS = 60_000;
